// Hook to read the injected AgentsApiClient from context.
// Throws when no provider is present so missing wiring fails loudly
// instead of producing a silent runtime crash inside a query function.

import { useContext } from 'react';
import { AgentsApiContext } from './AgentsApiContext';
import type { AgentsApiClient } from './types';

export function useAgentsApiClient(): AgentsApiClient {
  const client = useContext(AgentsApiContext);
  if (client === null) {
    throw new Error(
      'useAgentsApiClient: no AgentsApiProvider in the tree. ' +
        'Wrap the consumer in <AgentsApiProvider client={...}>.',
    );
  }
  return client;
}
